<template>
  <div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <div class="box__svg">
      <div style="width: 80%; margin: auto;">
        <h1 class="caption__select">
          <span>Seleccione una sección, clic para ver detalles</span>
        </h1>
        
        <!-- La imagen empieza a descargar de inmediato, sin esperar a los
             datos de disponibilidad — los polígonos (coords vacíos hasta que
             llega la data) simplemente no se ven hasta que estén listos. -->
        <div style="position: relative; background: rgb(240, 240, 240);">
          <div v-if="errorMsg" class="map-error-overlay">
            <p>⚠️ {{ errorMsg }}</p>
          </div>
          <div v-else-if="!imageLoaded || !dataLoaded" class="map-loading-overlay">
            <div class="loading show">
              <div class="spin"></div>
            </div>
          </div>
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 7988 6052"
            style="enable-background: new 0 0 1200 750"
            xml:space="preserve"
            @click="showCoordinatesOnConsole"
          >
          <image
            style="overflow: visible;"
            width="7988"
            height="6052"
            xlink:href="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/clubdegolf/MainClubGolfRecortadaV2.webp"
            @load="imageLoaded = true; golfImageLoadedSet()"
          ></image>
          <!-- Los polígonos esperan a que la imagen ya esté visible, sin
               importar qué tan rápido llegue la data (si no, se ven flotando
               solos sobre el fondo gris antes que la imagen). -->
          <g v-if="imageLoaded">
          <polygon
            class="polygon"
            v-for="(location, index) in development_data"
            @click.stop="selectLocation(location.id == '89' ? location.id : location.id == '93' ? location.level : '235&236')"
            :key="index"
            :style="{ fill: '#' + location.color, opacity: 0.6 }"
            :points="location.coords"
            :data-location-id="location.id"
            :data-name="location.name"
            v-tippy="{
              content: renderTooltip(location),
              theme: 'honeybee',
              size: 'large',
              distance: 3,
              arrow: true,
              interactive: true,
              animation: 'fade',
              allowHTML: true,
              ignoreAttributes: true
            }"
          />
          <polygon
            class="polygon"
            v-for="(location, index) in sectionB4yB7Locations"
            @click.stop="selectB4yB7Location(location)"
            :key="'b4yb7-' + index"
            :style="{ fill: '#31af67', opacity: 0.6 }"
            :points="location.coords"
            :data-location-id="location.id"
            :data-name="location.name"
            v-tippy="{
              content: renderTooltip({ name: location.name, totAvailable: location.available }),
              theme: 'honeybee',
              size: 'large',
              distance: 3,
              arrow: true,
              interactive: true,
              animation: 'fade',
              allowHTML: true,
              ignoreAttributes: true
            }"
          />
          </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "../../core/SubHeader.vue";
import { mapActions, mapGetters } from "vuex";

// Sobrevive a que el componente se destruya/recree al navegar fuera de
// /clubdegolf y volver — así no se vuelve a ver el "Cargando..." (aunque
// la imagen ya esté cacheada por el navegador, imageLoaded siempre
// arrancaría en false en una instancia nueva del componente si no fuera
// por esto).
let golfImageLoaded = false;

export default {
  name: "Main",
  components: {
    SubHeader,
  },
  data() {
    return {
      url: "clubdegolf",
      micrositeUrl: "https://tresmarias.com.mx/clubdegolf/terrenos",
      coordinates: [],
      torreEtapaInfo: {},
      dataLoaded: false, // ✅ Agregar bandera de carga
      imageLoaded: golfImageLoaded,
      errorMsg: "",
      sectionB4yB7Locations: [],
      development_data: {
        locationERM: {
          id: 89,
          level: 274,
          totAvailable: null,
          type: "SECCION C38",
          name: "SECCION C38",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationG3G4G5B9B11: {
          id: 84,
          level: 235,
          totAvailable: null,
          type: "GB",
          name: "SECCION GB",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationMH: {
          id: 84,
          level: 236,
          totAvailable: null,
          type: "MH",
          name: "MANZANA H",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationD13: {
          id: 93,
          level: 310,
          totAvailable: null,
          type: "D13",
          name: "PRIVADA D13",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationB4yB7: {
          id: 100,
          level: 337,
          totAvailable: null,
          type: "B4yB7",
          name: "SECCION B4yB7",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
  },
  methods: {
    ...mapActions(["getTotAvailableLocations", "getTowerStageLevels", "getAvailableLocations", "selectedLocation", "clearCoords"]),
    golfImageLoadedSet() {
      golfImageLoaded = true;
    },
    selectLocation(location) {
      console.log(location);
      this.$router.push({ path: `/clubdegolf/preseccion/${location}` });
    },
    selectB4yB7Location(location) {
      this.selectedLocation(location);
      this.$router.push({ path: `/clubdegolf/preseccion/detalles/${location.id}` });
    },
    showCoordinatesOnConsole(event) {
          const svg = event.target.closest('svg');
          const point = svg.createSVGPoint();

          point.x = event.clientX;
          point.y = event.clientY;

          const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

          // Guardar coordenadas en la lista
          this.coordinates.push(`${svgPoint.x.toFixed(2)},${svgPoint.y.toFixed(2)}`);

          // Imprimir TODAS las coordenadas en un string
          // const output = this.coordinates.join(' ');
          // console.log(output);
        },
    renderTooltip(location) {
      const totalAvailable = location.totAvailable ?? 0;
      const availableText = totalAvailable > 0 ? totalAvailable : "No disponible";

      return `
        <div class="tool">
          <div class="tool__content">
            <p>UBICACIÓN: <b style="font-size: small;">${location.name || ''}</b></p>
            <p>DISPONIBLE: <b class="disponible">${availableText}</b></p>
          </div>
        </div>
      `;
    }
  },
  async created() {
    // Limpieza defensiva antes de pedir nada nuevo: si este componente se
    // reutilizara entre navegaciones, ningún polígono/coord de una vista
    // anterior debe quedar visible mientras carga la nueva.
    this.errorMsg = "";
    this.sectionB4yB7Locations = [];
    Object.keys(this.development_data).forEach((key) => {
      this.development_data[key].coords = "";
      this.development_data[key].totAvailable = null;
    });

    try {
      // Las 5 secciones son independientes entre sí — se piden en paralelo
      // en vez de una por una (antes tardaban ~0.3s x 5 en serie = ~1.5s
      // solo de datos, antes de que empezara a bajar la imagen).
      const entries = Object.entries(this.development_data).filter(
        ([key]) => key !== "locationB4yB7"
      );

      const [levelResults, b4yb7Locations] = await Promise.all([
        Promise.all(entries.map(([, value]) => this.getTowerStageLevels(value))),
        this.getAvailableLocations({ id: 52, level: 337 }),
      ]);

      entries.forEach(([key, value], index) => {
        const torreInfo = levelResults[index];

        if (Array.isArray(torreInfo) && torreInfo.length > 0) {
          const matchingLevel = torreInfo.find(info => info.id === value.level);

          if (matchingLevel) {
            this.development_data[key].totAvailable = matchingLevel.available;
            this.development_data[key].color = matchingLevel.color;

            if (matchingLevel.available > 0) {
              this.development_data[key].coords = matchingLevel.coords;
            }

            this.torreEtapaInfo[value.id] = matchingLevel;
          }
        }
      });

      // SECCION B4yB7: locations/availability/52?towerId=337 ya regresa
      // únicamente estas 4 ubicaciones; solo se pintan si statusLocationID === 2 (verde)
      this.sectionB4yB7Locations = b4yb7Locations.filter(
        (loc) => loc.status === 2
      );
    } catch (error) {
      console.error('Error cargando datos de ubicaciones:', error);
      this.errorMsg = "No se pudo cargar la disponibilidad. Intenta recargar la página.";
    } finally {
      // ✅ Marcar como cargado cuando termine (con error o sin error)
      this.dataLoaded = true;
    }
  },
  async beforeDestroy() {
    await this.clearCoords();
  }
};
</script>
<style scoped>
.map-error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 6;
  text-align: center;
  padding: 50px 0;
  background: #fff3f3;
  color: #b00000;
  font-weight: 600;
}
.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(240, 240, 240);
}
</style>